(function () {
    'use strict';

    angular
        .module('sodAppointmentSelector')
        .controller('AppointmentSelectorController', AppointmentSelectorController);

    function AppointmentSelectorController(dialogOptions, close, lodash, $timeout, AppointmentSelectorConstant) {
        const vm = this;
        vm.show = false;
        vm.options = dialogOptions;

        vm.add = add;
        vm.STEP = AppointmentSelectorConstant.STEP;
        vm.step = vm.STEP.PARTICIPANTS;

        vm.participants = ['a', 'list', 'of', 'participants'];

        $timeout(function() {
           vm.show = true;
        });

        vm.nextStep = function() {
            switch (vm.step) {
                case vm.STEP.PARTICIPANTS: vm.step = vm.STEP.DATE_SELECTOR; break;
                case vm.STEP.DATE_SELECTOR: vm.step = vm.STEP.APPOINTMENT; break;
                default: break;
            }
        };

        vm.previousStep = function() {
            switch (vm.step) {
                case vm.STEP.APPOINTMENT: vm.step = vm.STEP.DATE_SELECTOR; break;
                case vm.STEP.DATE_SELECTOR: vm.step = vm.STEP.PARTICIPANTS; break;
                default: break;
            }
        };

        vm.dismiss = function() {
            close(false);
        };
        // Allow configuration of slots in company settings

        vm.sourcelistOptions = {
            dataSource: new kendo.data.DataSource({
                data: [
                    'a', 'b', 'c', 'd'
                ]
            })
        };

        function add(dataItem) {
            vm.participants.push(dataItem);
        }
    }
})();